import React from "react";
import { Space, Tag } from "antd";

const FIELD_LABELS = {
  name: "Company",
  code: "Customer Code",
  host_name: "Host Name",
  email: "Email",
  phone: "Phone",
  address: "Address",
  city: "City",
  state: "State",
  is_active: "Status",
  plan_id: "Plan",
  status: "Subscription Status",
  application_module: "Module",
  config_key: "Configuration Key",
};

const isMissingValue = (value) => value === null || value === undefined || value === "";

const displayValue = (field, value, entry, side) => {
  if (field === "plan_id") {
    return entry.plan_names?.[side] || (isMissingValue(value) ? "N/A" : String(value));
  }
  if (isMissingValue(value)) return "N/A";
  if (field === "is_active") return Number(value) === 1 || value === true ? "Active" : "Inactive";
  if (field === "status") {
    const normalizedStatus = String(value).trim().toLowerCase();
    return normalizedStatus ? `${normalizedStatus[0].toUpperCase()}${normalizedStatus.slice(1)}` : "N/A";
  }
  return typeof value === "boolean" ? (value ? "Yes" : "No") : String(value);
};

const valueColor = (field, value) => {
  if (isMissingValue(value)) return "default";
  if (field === "is_active") return Number(value) === 1 || value === true ? "green" : "red";
  if (field === "status") return String(value).toLowerCase() === "active" ? "green" : "orange";
  return "blue";
};

const CustomerHistoryDetails = ({ entry }) => {
  const before = entry.before || {};
  const after = entry.after || {};
  const fields = Array.from(new Set([...Object.keys(before), ...Object.keys(after)])).filter(
    (field) =>
      field === "config_value_changed" ||
      (field !== "customer_id" && field !== "isDeleted" && before[field] !== after[field])
  );

  if (!fields.length) return <Tag>No visible field changes</Tag>;

  return (
    <Space wrap size={[6, 8]}>
      {fields.map((field) => {
        if (field === "config_value_changed") {
          return <Tag color="cyan" key={field}>Configuration value updated</Tag>;
        }

        const label = FIELD_LABELS[field] || field.replaceAll("_", " ");
        const beforeValue = displayValue(field, before[field], entry, "before");
        const afterValue = displayValue(field, after[field], entry, "after");

        if (entry.action === "create") {
          return <Tag color={valueColor(field, after[field])} key={field}>{label}: {afterValue}</Tag>;
        }

        return (
          <Space key={field} size={3}>
            <Tag color={valueColor(field, before[field])}>{label}: {beforeValue}</Tag>
            <span style={{ color: "#94a3b8" }}>→</span>
            <Tag color={valueColor(field, after[field])}>{afterValue}</Tag>
          </Space>
        );
      })}
    </Space>
  );
};

export default CustomerHistoryDetails;
